module.exports = __webpack_public_path__ + "img/share_active.1c23ad74.svg";